import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
};

const forgotPasswordSlice = createSlice({
  name: "forgotpwd",
  initialState,
  reducers: {
      userForgetPasswordReset(state) {
          state.forgetSuccessMsg = null
          state.forgetError = null
      },
      userForgetPasswordSuccess(state, action) {
          state.forgetSuccessMsg = action.payload
          state.forgetError = null
      },
      userForgetPasswordError(state, action) {
          state.forgetError = action.payload
          state.forgetSuccessMsg = null
      },
  },
});

export const {
  userForgetPasswordReset,
  userForgetPasswordSuccess,
  userForgetPasswordError
} = forgotPasswordSlice.actions

export default forgotPasswordSlice.reducer;
